import { Anchor, Box, Breadcrumbs, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import classes from "./Breadcrumb.module.css";

type Props = {
  data: { label: string; to?: string }[];
};

/**
 * Plain «A / B / C» trail (13px, gray links, dark current page). A leading
 * `{ to: "/" }` item was the home icon of the old trail; it is dropped, so
 * callers that still pass it keep working.
 */
export function Breadcrumb({ data }: Props) {
  const trail = data.filter((item, index) => !(index === 0 && item.to === "/"));

  const items = trail.map((item, index) => {
    const isLast = index === trail.length - 1;

    if (item.to && !isLast) {
      return (
        <Anchor key={index} component={Link} to={item.to} className={classes.link} underline="never">
          {item.label}
        </Anchor>
      );
    }

    return (
      <Text key={index} component="span" className={classes.current}>
        {item.label}
      </Text>
    );
  });

  return (
    <Box>
      <Breadcrumbs
        separator="/"
        separatorMargin={6}
        classNames={{ root: classes.root, separator: classes.separator, breadcrumb: classes.breadcrumb }}
      >
        {items}
      </Breadcrumbs>
    </Box>
  );
}
